module.exports = __webpack_public_path__ + "img/25-P5Y.c3f2fa0.jpg";